import AppDispatcher from '../dispatcher/AppDispatcher';
import PaymentConstants from '../constants/PaymentConstants';
import ReservationConstants from '../constants/ReservationConstants';
import ReservationStore from '../stores/ReservationStore';
import SearchStore from "../stores/SearchStore";
import ProfileStore from "../stores/ProfileStore";
import ResultsStore from '../stores/ResultsStore';

import Analytics from 'arbitrip-common/client/analytics';

export default {
    clearPaymentData: function () {
        AppDispatcher.handleAction({
            actionType: PaymentConstants.CLEAR_PAYMENT_DATA
        })
    },

    markPaymentAsCharged: function () {
        AppDispatcher.handleAction({
            actionType: PaymentConstants.CREDIT_PAYMENT_CHARGED
        });

        const search_terms = SearchStore.getSearchTerms();
        const reservation = ReservationStore.getReservationData();
        const profile = ProfileStore.getProfile();
        const hotel_info = ResultsStore.getHotelById(reservation.destination);
        const { distanceInKm } = hotel_info;

        Analytics.actions.responses.bookingCreated(
            profile,
            reservation.destination,
            search_terms,
            reservation.deal,
            PaymentConstants.PAYMENT_METHODS_ANALYTICS.CREDIT_CARD,
            null,
            null,
            null,
            distanceInKm
        );
    },

    save3DSInformation: function (data) {
        AppDispatcher.handleAction({
            actionType: PaymentConstants.THREEDS_INFORMATION_DATA,
            data
        });
    },

    markPaymentAsFailed: function (err) {
        AppDispatcher.handleAction({
            actionType: PaymentConstants.CREDIT_PAYMENT_FAILED,
            data: { error_message: err }
        });

        let reservation = ReservationStore.getReservationData();
        let profile = ProfileStore.getProfile();

        Analytics.actions.responses.reservationFailed(
            profile,
            reservation.hotel,
            reservation.deal,
            PaymentConstants.PAYMENT_METHODS_ANALYTICS.CREDIT_CARD,
            err
        );
    },

    markPaymentAsCannotBeOpened: function () {
        AppDispatcher.handleAction({
            actionType: ReservationConstants.ADVANCE_RESERVATION_FAILURE
        });
    }
};
